// @ts-check

// Increased the version to "v2" because we removed the "light" theme.
// This avoid issues for customers who still have "fe-lib-theme-provider.theme = light" in local storage.
const LS_KEY = 'fe-lib-theme-provider.theme.v2';
// @ts-ignore
import { get, set } from 'fe-lib-localstorage';

export const getThemeName = (defaultThemeName) => get(LS_KEY, defaultThemeName);
export const setThemeName = (themeName) => set(LS_KEY, themeName);
